var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Keypress',{attrs:{"key-event":"keydown"},on:{"success":_vm.keyDown}})
}
var staticRenderFns = []

export { render, staticRenderFns }